var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70706 5.33822L1.55674 0.265572C1.47214 0.181421 1.3715 0.114629 1.26062 0.0690483C1.14973 0.0234675 1.0308 0 0.910672 0C0.790547 0 0.671612 0.0234675 0.560726 0.0690483C0.44984 0.114629 0.349199 0.181421 0.264607 0.265572C0.0951276 0.433789 0 0.661341 0 0.898531C0 1.13572 0.0951276 1.36327 0.264607 1.53149L4.76886 6.02056L0.264607 10.4647C0.0951276 10.633 0 10.8605 0 11.0977C0 11.3349 0.0951276 11.5624 0.264607 11.7307C0.348882 11.8155 0.449381 11.883 0.560282 11.9292C0.671182 11.9754 0.790279 11.9995 0.910672 12C1.03106 11.9995 1.15016 11.9754 1.26106 11.9292C1.37196 11.883 1.47246 11.8155 1.55674 11.7307L6.70706 6.65801C6.79942 6.57393 6.87314 6.4719 6.92355 6.35832C6.97397 6.24475 7 6.1221 7 5.99811C7 5.87412 6.97397 5.75148 6.92355 5.63791C6.87314 5.52433 6.79942 5.42229 6.70706 5.33822Z",
    fill: "#01AB6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.790372a7c8546f944700e73a8e269683.svg";
export { ForwardRef as ReactComponent };